import { useContext } from "react";
import { TransactionContext } from "context/transactionContext";

export const useTransactionContext = () => {
  const context = useContext(TransactionContext);

  return context;
};